import {createSvgIcon} from '../create-svg-icon';

export const KeyboardArrowDownIcon = createSvgIcon(
  <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
, 'KeyboardArrowDownOutlined');
